import { useFormik } from 'formik';
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { createRole, resetRoles } from '../../../redux/slice/roles/roleSlice';
import { getAllRoles } from '../../../redux/slice/staff/staffSlice';

const CreateRole = ({modal_id}) => {

    const { isSuccess } = useSelector((state) => state?.role);

  const close = useRef();
  const form = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (values) => {
    let payload = { ...values};
    dispatch(createRole(payload));
    close.current.click()
  };

  const validationScehma = Yup.object().shape({
    name: Yup.string("Role Name must be a string").required(
      "Role Name cannot be blank"
    ),
    description: Yup.string("Description must be a string").required(
      "Description cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      description: "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    if (isSuccess ) {
        close.current.click()
        dispatch(getAllRoles())
        dispatch(resetRoles())
        return;
    }
  }, [dispatch, isSuccess, navigate]);
  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4 text-dark'
            ref={form}
            onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Create Role
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  resetForm();
                  form.current.reset();
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='username'
                      className={`form-label mt-1  ${
                        errors?.name &&
                        touched?.name &&
                        "text-danger"
                      }`}
                    >
                      Name 
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      className={`form-control ${
                        errors?.name &&
                        touched?.name &&
                        "is-invalid"
                      }`}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.name && touched?.name && (
                      <p className='invalid-feedback mb-0'>
                        {errors?.name}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row'>
                    <div className='col-md-4 text-end sm-text-end'>
                        <label htmlFor='description' className={`form-label mt-1  ${errors?.description && touched?.description && "text-danger"}`}>
                            Description
                        </label>
                    </div>
                    <div className='col-md-8'>
                        <textarea
                        id='description'
                        name='description'
                        className={`form-control ${
                            errors?.description &&
                            touched?.description &&
                            "is-invalid"
                          }`}
                        value={values?.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        ></textarea>
                        {errors?.description && (
                            <p className='invalid-feedback mb-0'>
                                {errors?.description}
                            </p>
                        )}
                    </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3 mt-4'>
                <button
                    type='button'
                    className='btn btn-secondary btn-sm rounded-3'
                    data-bs-dismiss='modal'
                    onClick={() => {
                    resetForm();
                    form.current.reset();
                    }}
                >
                    Close
                </button>
                <button
                    type='submit'
                    className='btn btn-primary btn-sm rounded-3'
                >
                    Create
                </button>
            </div>
          </form>
        </div>  
      </div>
    </>
  )
}

export default CreateRole